module.exports = __webpack_public_path__ + "media/images/lb/250-e6ddd2c45f59b745cc641596e7c9c6f4.svg";